import { FaArrowLeft, FaEnvelope, FaDownload } from 'react-icons/fa';
import { useLanguage } from '../i18n';
import { localizeCv } from '../cvLocales';

const CV = ({ member, onBack }) => {
  const { language, t } = useLanguage();
  const cvData = {
    mariano: {
      name: "Mariano Paz",
      title: "Pixel-Artist Senior/Animador",
      email: "marianonpaz3@gmail.com",
      phone: "3865430651",
      location: "Tucuman, Argentina",
      about: "Me considero una persona comprometida con lo que hago, que trabaja con pasión y responsabilidad día a día. Disfruto del trabajo en equipo, de proponer ideas nuevas y de colaborar con otros. Estoy siempre dispuesto a aprender cosas nuevas y a ayudar o aclarar dudas cuando hace falta. Tengo buena capacidad de adaptación a distintas áreas de trabajo y valoro mucho el respeto y la cooperación.",
      skills: [
        "Animación 2D",
        "Pixel Art",
        "Diseño de Personajes",
        "Spritesheet",
        "Timing y Ritmo",
        "Cinemáticas",
        "Fondos 2D",
        "Atención al Detalle",
        "Trabajo en Equipo",
        "Adaptabilidad",
        "Creatividad",
        "Resolución Visual",
        "Proactividad"
      ],
      languages: [
        {
          language: "Inglés",
          level: "Intermedio"
        }
      ],
      experience: [
        {
          title: "Director de Arte/Pixel-Artist Senior/Animador",
          company: "Nuclear Team",
          period: "03/2025 - Presente",
          description: "Fundador junto con Ignacio Naval de Nuclear Team trabajamos en juegos propios tales como 'Op. C.H.O.R.I.' con el cual conseguimos la nominacion a 'Eva2025', trabajé en lo que es principalmente la creacion y animacion de personajes, jefes, Npcs, cinematicas y diseño de escenarios."
        },
        {
          title: "Pixel-Artist Senior/Animador",
          company: "Sneakfly Productions",
          period: "05/2024 - 12/2025",
          description: "Encargado de diseño de personajes y animacion para el videojuego 'DontPanik'(2024), tambien trabajos de outsourcing referidos a pixel art y arte."
        },
        {
          title: "Pixel-Artist Senior/Animador",
          company: "Sismo Games",
          period: "03/2023 - 07/2025",
          description: "Responsable de la animación de cinemáticas, escenarios y gran parte de los personajes jugables en un proyecto de videojuego denominado 'Skinwalker' (2026)"
        },
        {
          title: "Pixel-Artist Senior/Animador",
          company: "Ravegan Studios",
          period: "07/2020 - 01/2023",
          description: "Me desempeñé realizando diseños de personajes y animaciones de personajes Pixel-Art, tanto animales como vehiculos en proyectos como 'Stream Riders'(2020-2023), 'ORBRAWLERS' (2023), 'Blue Neon Rider'(2023), 'WilkSong'(2023)"
        },
        {
          title: "Pixel-Artist Junior",
          company: "Halberd Studios",
          period: "11/2019 - 05/2020",
          description: "Primera experiencia profesional en la industria. Me desempeñé realizando animaciones de efectos especiales en pixel art para el videojuego '9Years of Shadows'(2023) y colaborando en distintas tareas artísticas según los requerimientos del equipo y del proyecto"
        }
      ],
      education: [
        {
          degree: "Formación Autodidacta",
          institution: "Pixel Art y Animación 2D",
          period: "2019 - Presente"
        }
      ],
      projects: [
        "Op. C.H.O.R.I. - Dirección de Arte y Animación",
        "DontPanik - Diseño de Personajes y Animación",
        "Skinwalker - Cinemáticas y Animación",
        "9Years of Shadows - Efectos Especiales",
        "Stream Riders - Personajes y Animación",
        "ORBRAWLERS - Diseño y Animación",
        "Blue Neon Rider - Arte Pixel",
        "WilkSong - Personajes y Vehículos"
      ]
    },
    manu: {
      name: "Francisco Emanuel Diaz Ortiz",
      title: "Concept Artist | Ilustrador | Diseñador de Entornos y Props",
      email: "emanueldiaz.ortiz11@gmail.com",
      location: "Tucumán, Argentina",
      portfolio: "https://manud9.artstation.com",
      about: "Concept Artist e Ilustrador con experiencia en diseño de props, escenarios y desarrollo visual para videojuegos y medios digitales. Destaco por mi rapidez de producción, capacidad de adaptación a distintos estilos artísticos y habilidad para transformar ideas en conceptos visuales claros y funcionales. Cuento con experiencia en estudio profesional, proyectos freelance, game jams y desarrollo independiente.",
      skills: [
        "Concept Art",
        "Ilustración Digital",
        "Diseño de Entornos",
        "Diseño de Props",
        "Desarrollo Visual",
        "Composición y Color",
        "Adaptación de Estilos",
        "Trabajo en Equipo",
        "Producción Rápida"
      ],
      software: [
        "Krita",
        "Microsoft Office",
        "Google Workspace",
        "Herramientas de apoyo conceptual con IA"
      ],
      languages: [
        {
          language: "Español",
          level: "Nativo"
        },
        {
          language: "Inglés",
          level: "Intermedio"
        }
      ],
      experience: [
        {
          title: "Ilustrador Freelance",
          company: "Proyecto Editorial",
          period: "2026 - Actualidad",
          description: [
            "Ilustración de material para un libro actualmente en desarrollo.",
            "Creación de imágenes basadas en requerimientos narrativos y visuales.",
            "Colaboración con el autor para construir una identidad visual coherente."
          ]
        },
        {
          title: "Concept Artist",
          company: "SneakFly",
          description: [
            "Diseño de props, escenarios y conceptos visuales para proyectos de videojuegos.",
            "Producción de concept art para apoyar el pipeline artístico.",
            "Adaptación a diferentes estilos visuales según las necesidades del proyecto."
          ]
        }
      ],
      projects: [
        {
          title: "Proyecto de Videojuego Independiente",
          description: [
            "Desarrollo de la dirección visual de un videojuego propio.",
            "Diseño de personajes, escenarios, props y construcción de mundo."
          ]
        },
        {
          title: "Participación en Game Jam",
          description: [
            "Trabajo colaborativo en equipo multidisciplinario bajo plazos ajustados.",
            "Creación de assets y conceptos visuales para prototipos de videojuegos."
          ]
        }
      ]
    },
    nacho: {
      name: "Ignacio Naval Esparrell",
      title: "Software Engineer & Game Developer",
      email: "ignacionaval52@gmail.com",
      phone: "+54 3814149896",
      location: "Tucumán, Argentina",
      resume: "/cv/ignacio-naval-esparrell.pdf",
      about: "Software Engineer with 5+ years of experience in Android and game development, specializing in Kotlin, Jetpack Compose, Godot, and Unity. Experience building enterprise banking applications, leading game development initiatives, and delivering interactive products for international clients including Cartoon Network and Discovery.",
      skills: [
        "Kotlin",
        "JavaScript",
        "TypeScript",
        "Python",
        "C#",
        "Jetpack Compose",
        "Godot",
        "Unity",
        "Phaser.js",
        "React",
        "Express.js",
        "Redux",
        "Git",
        "Android Studio",
        "RXJava",
        "Mockito",
        "MongoDB",
        "Charles Proxy",
        "Hilt",
        "Jira",
        "Matter.js",
        "HTML5",
        "CSS"
      ],
      experience: [
        {
          title: "Game Developer",
          company: "TVC Games",
          period: "Feb 2025 - Present",
          description: "Godot Engine development leader across multiple projects and clients. Main Unity developer and lead developer of an interactive game for EDET used at client exhibitions. Optimized the Godot Engine project 'En el nombre de La Ley'. Tech: Unity, Godot Engine, Git, Jira."
        },
        {
          title: "Nuclear Team Co-Founder",
          company: "Nuclear Team",
          period: "Feb 2023 - Present",
          description: "Co-producer and lead game developer. Co-founded the indie studio and currently develops O.P. C.H.O.R.I., nominated for the MPVP 2025 Awards by the Asociación de Desarrolladores de Videojuegos Argentinos at Exposición de Videojuegos Argentina 2025. Tech: Godot Engine, Git."
        },
        {
          title: "Android Developer",
          company: "Globant (Client: Citibanamex)",
          period: "Nov 2021 – Jun 2025",
          description: "Contributed to the development and maintenance of the Citibanamex Android home banking application. Implemented new features and resolved bugs to support ongoing banking initiatives. Collaborated with a distributed Agile team, participating in code reviews and sprint planning."
        },
        {
          title: "SSr Web Game Developer / Technology Leader",
          company: "Live Media Digital Agency",
          period: "Dec 2019 – Jun 2023",
          description: "Developed interactive web games for Cartoon Network, Nickelodeon, and Discovery. Led technology choices for multiple projects, ensuring scalable and maintainable solutions."
        }
      ],
      education: [
        {
          degree: "Programming Technician",
          institution: "Universidad Tecnológica Nacional",
          period: "2020 – 2022"
        },
        {
          degree: "Cambridge First Certificate in English (B2)",
          institution: "Cambridge",
          period: "2017"
        }
      ],
      projects: [
        "O.P. C.H.O.R.I. - Co-Production and Lead Game Development",
        "En el nombre de La Ley - Godot Engine Optimization",
        "EDET Interactive Game - Lead Development",
        "Citibanamex Android App - Development",
        "Cartoon Network Web Games - Development",
        "Nickelodeon Interactive Games - Technology Leadership"
      ],
      leadership: [
        {
          title: "Game Development Club Mentor (Ad honorem)",
          organization: "Universidad Nacional de Tucumán",
          period: "2022 – 2024",
          description: "Mentored students in game development with Godot Engine, guiding projects and game jams. Created initiatives that united students across specializations to build collaborative games."
        },
        {
          title: "Regional Leader & Delegate (Volunteer)",
          organization: "World Cube Association",
          period: "2022 – Present",
          description: "Organized and led 30+ international competitions with 500+ participants. Managed staff, logistics, and compliance, ensuring fair and engaging events. Promoted community growth and trained new delegates across South America."
        }
      ]
    },
    tomas: {
      name: "TOMÁS HEREDIA",
      title: "INFORMATIC ENGINEER - GAME DESIGNER & DEVELOPER",
      email: "herediatomas0420@gmail.com",
      phone: "+543816839493",
      location: "Buenos Aires",
      portfolio: "https://podolsqui.itch.io",
      about: "Informatic Engineer and Game Designer with extensive experience in video game design and development. With over 4 years of active participation in game jams and as a member of the Tucumán Video Game Developers Community Committee, I have demonstrated skills in team leadership, creativity, and project management. Passionate about creating high-quality interactive experiences and fostering skill development in other community members.",
      skills: [
        "GDScript",
        "Python",
        "C",
        "C#",
        "C++",
        "HTML",
        "CSS",
        "MySQL",
        "Windows PowerShell",
        "Godot Engine",
        "Unreal Engine",
        "Visual Studio Code",
        "Git",
        "Aseprite",
        "AI"
      ],
      languages: [
        {
          language: "Spanish",
          level: "Native"
        },
        {
          language: "English",
          level: "C1"
        },
        {
          language: "Japanese",
          level: "B2"
        }
      ],
      experience: [
        {
          title: "PROFESSOR AND DEVELOPER",
          company: "Video Game Development Club - National University of Tucumán",
          period: "Aug 2021 - Dec 2024",
          description: "Founder of the club. Delivered classes on Godot Engine and other aspects of video game development. Organized game jams and video game creation activities within the club. Designed and programmed projects with students and collaborators."
        },
        {
          title: "DEVELOPER",
          company: "programmer – TVC",
          period: "Aug 2024 - Present",
          description: "Programmed main mechanics, dialogue systems, 3D movement, and UI/UX design for 'En el nombre de la Ley', a video game for Tucumán's Legislature in Godot."
        },
        {
          title: "DEVELOPER",
          company: "Video Game 'O.P Chori' - Nuclear Team",
          period: "Jul 2024 - Present",
          description: "Developed bosses, parallax, enemy mechanics, camera design, levels, and UI/UX in Godot."
        },
        {
          title: "CDVT MEMBER",
          company: "Tucumán Video Game Developers Community Committee",
          period: "Feb 2023 - Present",
          description: "Organized community events such as My First Professional Video Game, Global Game Jams, Tucumán Makes Video Games, among others. Active representative of the community in local media."
        },
        {
          title: "GAME DESIGNER AND TEAM LEADER",
          company: "Development of 'The Judgment of the Lost Souls' - Global Game Jam",
          period: "Mar 2024",
          description: "Designed story, characters, setting, and core mechanics. Coordinated the team and made key decisions for development."
        }
      ],
      education: [
        {
          degree: "Informatic Engineering",
          institution: "National University of Tucumán",
          period: "2019 - 2024"
        }
      ],
      courses: [
        {
          name: "Video Game Development with Unreal Engine 5",
          institution: "Image Campus",
          period: "Aug - Dec 2024"
        }
      ],
      projects: [
        "O.P Chori - Development and Programming",
        "En el nombre de la Ley - Programming and Systems",
        "The Judgment of the Lost Souls - Game Design and Leadership",
        "Global Game Jam Projects - Multiple Games"
      ]
    },
  };

  const memberKey = member.toLowerCase();
  const data = localizeCv(cvData[memberKey], memberKey, language);

  if (!data) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-white mb-4">{t('notFound')}</h2>
          <button
            onClick={onBack}
            className="px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-semibold transition-all duration-300"
          >
            {t('back')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-purple-800 to-indigo-900 px-4 py-8 sm:py-12">
      <div className="max-w-4xl mx-auto">
        {/* Back Button */}
        <button
          onClick={onBack}
          className="flex items-center gap-2 text-white hover:text-purple-300 transition-colors mb-6 sm:mb-8"
        >
          <FaArrowLeft size={20} />
          <span className="font-medium">{t('backTeam')}</span>
        </button>

        {/* CV Content */}
        <div className="bg-white/10 backdrop-blur-md rounded-2xl border border-white/20 overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-purple-600/30 to-pink-600/30 p-6 sm:p-8 border-b border-white/20">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div>
                <h1 className="text-3xl sm:text-4xl font-bold text-white mb-2">{data.name}</h1>
                <p className="text-xl text-purple-200 mb-4">{data.title}</p>
                <div className="flex flex-wrap gap-4 text-purple-200 text-sm sm:text-base">
                  {data.email && (
                    <a className="flex items-center gap-2 hover:text-white transition-colors" href={`mailto:${data.email}`}>
                      <FaEnvelope size={16} />
                      {data.email}
                    </a>
                  )}
                  {data.phone && <span>{data.phone}</span>}
                  {data.location && <span>{data.location}</span>}
                </div>
                {(data.linkedin || data.portfolio) && (
                  <div className="flex flex-wrap gap-4 mt-3 text-purple-200 text-sm">
                    {data.linkedin && (
                      <span className="flex items-center gap-2">
                        LinkedIn: {data.linkedin}
                      </span>
                    )}
                    {data.portfolio && (
                      <a
                        className="flex items-center gap-2 hover:text-white transition-colors"
                        href={data.portfolio}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Portfolio: {data.portfolio.replace(/^https?:\/\//, '')}
                      </a>
                    )}
                  </div>
                )}
              </div>
              {data.resume && (
                <a
                  href={data.resume}
                  download
                  className="px-4 sm:px-6 py-2 sm:py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-lg font-semibold transition-all duration-300 flex items-center gap-2 self-start sm:self-auto"
                >
                  <FaDownload size={16} />
                  {t('downloadCv')}
                </a>
              )}
            </div>
          </div>

          <div className="p-6 sm:p-8 space-y-8">
            {/* About */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">{t('about')}</h2>
              <p className="text-purple-200 leading-relaxed">{data.about}</p>
            </section>

            {/* Skills */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">{t('skills')}</h2>
              <div className="flex flex-wrap gap-2">
                {data.skills.map((skill, index) => (
                  <span
                    key={index}
                    className="px-3 py-1 bg-purple-600/30 border border-purple-500/50 rounded-full text-purple-200 text-sm"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </section>

            {/* Software */}
            {data.software?.length > 0 && (
              <section>
                <h2 className="text-2xl font-bold text-white mb-4">{t('software')}</h2>
                <div className="flex flex-wrap gap-2">
                  {data.software.map((item, index) => (
                    <span
                      key={index}
                      className="px-3 py-1 bg-purple-600/30 border border-purple-500/50 rounded-full text-purple-200 text-sm"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </section>
            )}

            {/* Languages */}
            {data.languages?.length > 0 && (
              <section>
                <h2 className="text-2xl font-bold text-white mb-4">{t('languages')}</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {data.languages.map((lang, index) => (
                    <div key={index} className="bg-white/5 rounded-lg p-3 border border-white/10">
                      <p className="text-white font-medium">{lang.language}</p>
                      <p className="text-purple-300 text-sm">{lang.level}</p>
                    </div>
                  ))}
                </div>
              </section>
            )}

            {/* Certifications */}
            {data.certifications && (
              <section>
                <h2 className="text-2xl font-bold text-white mb-4">{t('certifications')}</h2>
                <div className="space-y-3">
                  {data.certifications.map((cert, index) => (
                    <div key={index} className="border-l-2 border-purple-500/50 pl-4">
                      <h3 className="text-lg font-semibold text-white">{cert.name}</h3>
                      <p className="text-purple-300 text-sm">{cert.issuer}</p>
                      {cert.level && <p className="text-purple-400 text-xs">{cert.level}</p>}
                    </div>
                  ))}
                </div>
              </section>
            )}

            {/* Experience */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">{t('experience')}</h2>
              <div className="space-y-4">
                {data.experience.map((exp, index) => (
                  <div key={index} className="border-l-2 border-purple-500/50 pl-4">
                    <h3 className="text-lg font-semibold text-white">{exp.title}</h3>
                    {exp.company && <p className="text-purple-300 font-medium">{exp.company}</p>}
                    {exp.period && <p className="text-purple-400 text-sm mb-2">{exp.period}</p>}
                    {Array.isArray(exp.description) ? (
                      <ul className="list-disc space-y-1 pl-5 text-purple-200">
                        {exp.description.map((item, descriptionIndex) => (
                          <li key={descriptionIndex}>{item}</li>
                        ))}
                      </ul>
                    ) : (
                      <p className="text-purple-200">{exp.description}</p>
                    )}
                  </div>
                ))}
              </div>
            </section>

            {/* Education */}
            {data.education?.length > 0 && (
              <section>
                <h2 className="text-2xl font-bold text-white mb-4">{t('education')}</h2>
                <div className="space-y-3">
                  {data.education.map((edu, index) => (
                    <div key={index} className="border-l-2 border-purple-500/50 pl-4">
                      <h3 className="text-lg font-semibold text-white">{edu.degree}</h3>
                      <p className="text-purple-300 font-medium">{edu.institution}</p>
                      <p className="text-purple-400 text-sm">{edu.period}</p>
                    </div>
                  ))}
                </div>
              </section>
            )}

            {/* Courses */}
            {data.courses && (
              <section>
                <h2 className="text-2xl font-bold text-white mb-4">{t('courses')}</h2>
                <div className="space-y-3">
                  {data.courses.map((course, index) => (
                    <div key={index} className="border-l-2 border-purple-500/50 pl-4">
                      <h3 className="text-lg font-semibold text-white">{course.name}</h3>
                      <p className="text-purple-300 text-sm">{course.institution}</p>
                      <p className="text-purple-400 text-xs">{course.period}</p>
                    </div>
                  ))}
                </div>
              </section>
            )}

            {/* Projects */}
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">{t('featuredProjects')}</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {data.projects.map((project, index) => (
                  <div key={index} className="bg-white/5 rounded-lg p-3 border border-white/10">
                    {typeof project === 'string' ? (
                      <p className="text-purple-200">{project}</p>
                    ) : (
                      <>
                        <h3 className="font-semibold text-white">{project.title}</h3>
                        {Array.isArray(project.description) ? (
                          <ul className="list-disc space-y-1 pl-5 mt-2 text-sm text-purple-200">
                            {project.description.map((item, descriptionIndex) => (
                              <li key={descriptionIndex}>{item}</li>
                            ))}
                          </ul>
                        ) : (
                          <p className="mt-2 text-sm text-purple-200">{project.description}</p>
                        )}
                      </>
                    )}
                  </div>
                ))}
              </div>
            </section>

            {/* Leadership & Additional Experience */}
            {data.leadership && (
              <section>
                <h2 className="text-2xl font-bold text-white mb-4">{t('leadership')}</h2>
                <div className="space-y-4">
                  {data.leadership.map((leadership, index) => (
                    <div key={index} className="border-l-2 border-purple-500/50 pl-4">
                      <h3 className="text-lg font-semibold text-white">{leadership.title}</h3>
                      <p className="text-purple-300 font-medium">{leadership.organization}</p>
                      <p className="text-purple-400 text-sm mb-2">{leadership.period}</p>
                      <p className="text-purple-200">{leadership.description}</p>
                    </div>
                  ))}
                </div>
              </section>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CV;
